import React, {useState} from 'react';
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {FL_CODE, FL_STATUS} from "../../../components/i18n/formLabels";

function TypeServicesFilters(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app, udn } = componentState?.data;

    const [status, setStatus] = useState(filter?.item?.status || null);
    const [resetValues, setResetValues] = useState(false);
    const [onlyRegistered, setOnlyRegistered] = useState(true);


    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            code: filter?.item?.code,
        }
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
                udn : { id : udn.id }
            }
        }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
        }
        props.setFilter(path, tmpFilter);
        setOnlyRegistered(true)
        setResetValues(!resetValues);
        reset()
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="4">
                        <Label>{FL_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            innerRef={register}
                        />
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Solo en app'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeServicesFilters)